import { writable } from 'svelte/store';
export const remoteVideoStore = writable(null);
export const remoteAudioStore = writable(null);
